import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
export function ProblemSolutionSection() {
  const cards = [{
    problem: 'Using knives can be unsafe.',
    solution: 'Hands-free peeling keeps fingers away from blades. Just secure the fruit, press a button, and let the machine do the rest—safe for kids, adults, and seniors.',
    image: 'https://cdn.magicpatterns.com/uploads/31YTmmEYi7MZx6mcpAeEgF/image.png'
  }, {
    problem: 'Peeling by hand can be messy and uneven.',
    solution: 'The sharp stainless-steel blade delivers smooth, even peels with no waste or mess. Your fruits and veggies come out neat and ready to serve or cook.',
    image: 'https://cdn.magicpatterns.com/uploads/dwBnGWRNHMkwPaH8zbWvGG/image.png'
  }, {
    problem: 'Bulky tools clutter the kitchen.',
    solution: "Compact and lightweight, this peeler fits easily into any cabinet or drawer. It's powerful yet space-saving—ideal for neat kitchens and small apartments.",
    image: 'https://cdn.magicpatterns.com/uploads/1bUxGdr5CbnUVmqwAiTntR/image.png'
  }, {
    problem: 'Manual peeling takes too long.',
    solution: 'With one-touch automatic operation, this machine peels apples, pears, potatoes, and more in seconds. No more wasting time over the sink—perfect for busy mornings, quick dinners, or party prep.',
    image: 'https://cdn.magicpatterns.com/uploads/4UdSvbLuX7Zyykj4X1PwQs/image.png'
  }];
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-198">
      {/* Heading */}
      <div className="text-center mb-10" data-id="element-199">
        <h2 className="text-3xl md:text-4xl font-bold text-black mb-3" data-id="element-200">
          Peeling fruits and vegetables by hand is time-consuming and tiring.
        </h2>
        <p className="text-2xl md:text-3xl font-bold text-blue-900" data-id="element-201">
          Try the Automatic Fruit Peeling Machine!
        </p>
      </div>

      {/* Problem/Solution Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-202">
        {cards.map((card, index) => <div key={index} className="flex flex-col rounded-2xl overflow-hidden shadow-lg" data-id="element-203">
            {/* Problem Section */}
            <div className="bg-gray-300 p-4" data-id="element-204">
              <div className="flex items-start gap-2 mb-3" data-id="element-205">
                <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-206" />
                <p className="font-bold text-black text-sm leading-tight" data-id="element-207">
                  {card.problem}
                </p>
              </div>

              {/* Problem Image */}
              <div className="w-full aspect-square bg-gray-200 rounded-lg overflow-hidden" data-id="element-208">
                <img src={card.image} alt="Problem illustration" className="w-full h-full object-cover grayscale" data-id="element-209" />
              </div>
            </div>

            {/* Solution Section */}
            <div className="bg-blue-900 p-4 flex-1 flex flex-col" data-id="element-210">
              <div className="flex items-start gap-2 mb-2" data-id="element-211">
                <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-212" />
                <p className="font-bold text-white text-sm" data-id="element-213">Our Solution:</p>
              </div>
              <p className="text-white text-sm leading-relaxed" data-id="element-214">
                {card.solution}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}